import View from 'views/base/view';
import utils from 'lib/utils';
import DialogContentTemplate from './templates/dialog-content';
import DialogContentLightboxTemplate from './templates/dialog-content-lightbox';

const ModalContentView = View.extend({
  noWrap: true,
  autoRender: true,
  initialize: function (options) {
    this.parent = options.parent;
    this.template =
      this.parent.model.get('modal_style') === 'lightbox' ? DialogContentLightboxTemplate : DialogContentTemplate;
    utils.setHeadingLevel(this.model, this.model.get('heading_level'));
    View.prototype.initialize.apply(this, arguments);
  },

  getTemplateData: function () {
    return this.parent.model.attributes;
  },

  getTemplateFunction() {
    return this.template;
  },
});

export default ModalContentView;
